import { FormsyRadioGroup, Radio } from '@thanx/uikit/radio'
import { LinkTarget } from 'api/landingPageTheme'
import useFlag from 'hooks/useFlag'
import { buildTranslate } from 'locales'
import React from 'react'
import { UrlType, UrlValue } from './UrlPicker'

const t = buildTranslate('cms.components.link_target_picker')

const DEFAULT_LINK_TARGET: LinkTarget = 'in_app_webview'

type Props = {
  id: string
  url: UrlValue
  linkTarget?: LinkTarget
}

// FeaturedContent and PersonalizedText are the only content blocks with a merchant-set URL.
const LinkTargetPicker = ({ id, url, linkTarget }: Props) => {
  const enabled = useFlag('content-block-link-target-mx', false)
  if (!enabled || url.type !== UrlType.External) return <></>

  return (
    <FormsyRadioGroup
      className="mt-m mb-m"
      name={`${id}.settings.link_target`}
      label={t('label')}
      align="vertical"
      value={linkTarget ?? DEFAULT_LINK_TARGET}
    >
      <Radio className="mr-s" value="in_app_webview">
        {t('in_app_webview')}
      </Radio>
      <Radio value="external_browser">{t('external_browser')}</Radio>
    </FormsyRadioGroup>
  )
}

export default LinkTargetPicker
